export const getCurrentLang = (pathname) =>
  pathname?.startsWith("/pl/") ? "pl" : "en";
